// This script is used to redirect users based on their geolocation and language preference.;
const userLanguageChoice = {
  fr_ca: "fr-CA",
  en_ca_prod: "getbevel.com",
  en_ca_stage: "bevel-skincare-dev.myshopify.com",
  userLanguageChoice: "userLanguageChoice",
};
const consentMessage =
  "<p style='margin:20px;'>This site is not accessible in your region. <br/><br/>Ce site n'est pas accessible dans votre région.</p>";

document.addEventListener("DOMContentLoaded", function () {
  handleQuebecRedirection();

  const onFrenchConsent = () => {
    sessionStorage.setItem("userLanguageChoice", userLanguageChoice.fr_ca);
    document.body.innerHTML = consentMessage;
  };

  function handleQuebecRedirection() {
    const userChoice = sessionStorage.getItem(userLanguageChoice.userLanguageChoice);
    const currentPath = window.location.pathname;
    const curretHost = window.location.hostname;
    const redirectToLanguage = () => {
      document.body.innerHTML = consentMessage;
    };
    const handleGeoLocationSuccess = () => {
      const location = window.OneTrust.getGeolocationData();

      const isWithinRegion = location.country === "CA" && location.state === "QC";
      const isEnglishPath = curretHost.includes(`${userLanguageChoice.en_ca_prod}`) || curretHost.includes(`${userLanguageChoice.en_ca_stage}`);
      if (!userChoice && isEnglishPath && isWithinRegion) {
        onFrenchConsent();
      }
    };

    if (!currentPath.includes(`/${userLanguageChoice.fr_ca}`)) {
      if (!userChoice) {
        window.OptanonWrapper = handleGeoLocationSuccess;
      } else if (userChoice === userLanguageChoice.fr_ca && (curretHost.includes(`/${userLanguageChoice.en_ca_prod}`) ||
          curretHost.includes(`/${userLanguageChoice.en_ca_stage}`))) {
        redirectToLanguage();
      }
    }
  }
});
